export const InfoSummary = ({ amenities }) => {
  return (
    <div className="flex flex-col border-t border-slate-300 gap-6 pt-8 pb-10 lg:pr-8">
      {amenities.map((item, i) => (
        <div className="flex" key={i}>
          {item.iconName && (
            <i
              className={`inline-flex justify-center items-center text-primary-800 self-start max-sm:text-[24px] text-[36px] icon-mr icon-${item.iconName}`}
            />
          )}
          <div className="flex flex-col gap-[6px] self-center">
            <div className="text-slate-700 text-base sm:text-lg font-semibold">
              {item.name}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
